export const zipCodeSelector = (state) => state.inventoryNearYou.zipCode;
export const defaultZipCodeSelector = (state) => state.inventoryNearYou.defaultZipCode;
export const inventoryResultSelector = (state) => state.inventoryNearYou.inventoryResult;
export const statusSelector = (state) => state.inventoryNearYou.status;
export const errorsSelector = (state) => state.inventoryNearYou.errors;